import React from "react";

type TResultProps<
    TComponent extends React.ComponentType<unknown>,
    TKey extends keyof React.ComponentPropsWithoutRef<TComponent>
> = Omit<React.ComponentPropsWithoutRef<TComponent>, TKey> &
    Partial<Pick<React.ComponentPropsWithoutRef<TComponent>, TKey>>;

export default function withProps<
    TComponent extends React.ComponentType<unknown>,
    TKey extends keyof React.ComponentPropsWithoutRef<TComponent>
>(
    WrappedComponent: TComponent,
    defaultProps: Pick<React.ComponentPropsWithoutRef<TComponent>, TKey>
): React.FC<TResultProps<TComponent, TKey>> {
    return componentProps => {
        return (
            <WrappedComponent
                {...({
                    ...defaultProps,
                    ...componentProps
                } as any)}
            />
        );
    };
}
